import React from 'react';
import { classNames } from '../../utils/style';
import { Image } from '../../components/Image';
import { ImageProps } from '../Image/types';
export interface LogoProps extends ImageProps {
  isEncapsulated?: boolean;
  isAnimated?: boolean;
  classNameLogo?: string;
}

export const Logo = ({
  isEncapsulated = false,
  isAnimated = false,
  classNameLogo,
  className,
  ...props
}: LogoProps) => {
  return (
    <div
      className={classNames(
        'Logo',
        isEncapsulated ? 'px-20 h-80 bg-neutral-1' : 'w-[151px] h-80',
        'flex items-center justify-center',
        className,
        isAnimated && 'animated rounded-12 mx-8'
      )}
    >
      <Image {...props} className={classNames(classNameLogo)} />
    </div>
  );
};
